export const StorageMixin = (superClass) => class extends superClass {
    
    connectedCallback() {
        super.connectedCallback()
       
        let proto = Object.getPrototypeOf(this)
        for (let [name, prop] of Object.entries(proto.constructor.properties)) {
            if (prop.store) {
                let prop_key = this[name]
                window.objectStorage.subscribe(this, prop_key)

                Object.defineProperty(this, name, {
                    get: function() {
                        return window.objectStorage.getItem(prop_key)
                    },
                    set: function(newValue) {
                        window.objectStorage.setReactiveItem(prop_key, newValue)
                    }
                })
            } 
        }    
    }

    disconnectedCallback() {
        super.disconnectedCallback()

        let proto = Object.getPrototypeOf(this)
        for (let [name, prop] of Object.entries(proto.constructor.properties)) {
            if (prop.store) {
                let prop_key = this[name]
                window.objectStorage.unsubscribe(this, prop_key)
            } 
        }
    }

    storageCallback() {
        this.requestUpdate()
    }
}